(function() {

    var form_dependent_group_module = (function() {
        
        function areArraysIntersected(first_array, second_array) {
            
            var intersected_values = first_array.filter(
    
                function(value) {
                    return second_array.indexOf(value) !== -1;
                    
                })
            
            //console.log(intersected_values.length);
            
            return intersected_values.length;
            
        }
        
        function getSelectedValues($field) {
            
            var selected_values_array = [];
            
            var field_type = $field.prop("type");
            var field_name = $field.prop("name");
            
            if (field_type === "radio" || field_type === "checkbox") {
                
                $("[name='" + field_name + "']:checked").each(function(){
                    selected_values_array.push($(this).val());
                });
                
            } else {
                
                // This will usually apply to select fields
    
                var selected_value = $field.val().trim();
    
                // Have to check if empty because empty value attribute in
                // select is equal to ""
                if (selected_value.length) {
                    selected_values_array.push($field.val().trim());
                }
    
            }
            
            //console.log("Selected field value of " + field_name + " is " + selected_values_array);
            
            return selected_values_array;
            
        }
        
        function showGroup($dependent_group) {
            
            $dependent_group.show();
            
            $dependent_group.find("[data-required]").prop('required', true);
            
        }
        
        function hideGroup($dependent_group) {
            
            // Find all fields (exclude buttons)
            var $fields = $dependent_group.find(":input").not(":button, :submit, :reset, :hidden");
            
            // Get text inputs
            var $text_inputs = $fields.not("select, :checkbox, :radio");
            
            // Get selects
            var $selects = $fields.filter("select");
            
            // Get checked checkboxes and radios
            var $checked_checkbox_radios = $fields.filter(":checkbox, :radio").filter(":checked");
            
            // Clear values first
            $text_inputs.val("");
            $selects.prop('selectedIndex',0);
            $checked_checkbox_radios.prop('checked', false);
            
            // Then trigger change event
            $text_inputs.add($selects).add($checked_checkbox_radios).change();
            
            // Make required fields not required so that form can submit
            $fields.filter("[required]").prop('required', false).attr("data-required","");
            
            $dependent_group.hide();
            
        }
        
        function checkDependentGroupsMatching($field) {
            
            // Get array of selected values (single for selects and radios, multiple for checkboxes)
            var this_field_selected_values_array = getSelectedValues($field);
            
            // Get this master field name
            // Remember that if this a checkboxe, it will have "[]" in its name so we need to remove it so that 
            // we can find this field later in dependent group maps e.g. this_field_dependent_group_map[this_field_name]
            var this_field_name = $field.prop("name").replace('[]','');
            
            // Get the dependent groups which will be an array of jQuery objects
            var $field_dependent_groups = $field.data("dependent-groups");
            
            // For each dependent group (jQuery object)
            $field_dependent_groups.each(function( index ) {
            
                var $field_dependent_group = $(this);
                
                // Get the map. Should be an object returned
                var this_field_dependent_group_map = $field_dependent_group.data("dependent-on");
                
                // Get the matching values by checking the dependent group mapping field first
                // this_field_name should have "[]" removed by then
                var this_field_dependent_group_match_values_string = this_field_dependent_group_map[this_field_name];
                
                // If the dependent group has been mapped to show if any field value is selected (as long as its not empty) and dependent map string is star
                // e.g. "q4750:q6": "*"
                if (this_field_selected_values_array.length && this_field_dependent_group_match_values_string === "*") {
                    
                    // Show the group
                    showGroup($field_dependent_group);
                    
                } else {
                    
                    // Dependent group will show only if a certain field value is selected. Check here.
                    
                    // Split the string first into an array
                    var this_field_dependent_group_match_values_array = this_field_dependent_group_map[this_field_name].split(",");
                
                    // Check length of array if theres a match by intersecting the two arrays
                    if (areArraysIntersected(this_field_dependent_group_match_values_array, this_field_selected_values_array)) {
                        // A match!
                        // Show the group
                        showGroup($field_dependent_group);
    
                    } else {
                        
                        // No match!
                        // But we must still check the other fields this dependent group is depending on
                        // Other master fields might still have a matching value
                        var has_match = false;
                        
                        // Loop through each field in the map
                        $.each( this_field_dependent_group_map, function( other_field_name, other_matching_values_string ) {
                            
                            // We don't need to check against the current field thats changed
                            if (other_field_name !== this_field_name) {
                            
                                // For checkboxes, matrix generates checkbox names ending with "[]" in the markup
                                // To keep things simple for the client, the name of the field is entered in to the data-dependent-on attribute without "[]"
                                var $other_field = $("[name='" + other_field_name + "'], [name='" + other_field_name + "[]']");
                                
                                //console.log("Other field name: " + other_field_name);
                                
                                if ($other_field.length) {
                                    
                                    var other_selected_value_array = getSelectedValues($other_field);
                            
                                    if (other_selected_value_array.length) {
                                        
                                        if (other_matching_values_string === "*") {
                        
                                            has_match = true;
                                            
                                            return false; // Break the each loop as soon as its been set to true
                                            
                                        } else {
                                            
                                            var other_matching_values_array = other_matching_values_string.split(",");
    
                                            // Check length of array if theres a match by intersecting the two arrays
                                            if (areArraysIntersected(other_matching_values_array, other_selected_value_array)) {
                                        
                                                // A match!
                                                // Set flag to true
                                                has_match = true;
                                                
                                                return false; // Break the each loop as soon as its been set to true
                                        
                                            }
                                            
                                        }
                                        
                                    }
                                
                                } else {
                                    console.log(other_field_name + " does not exist!");
                                }
                                
                            }
                            
                        });
                        
                        // At this point, we've gone through the other fields in the map
                        if (has_match) {
                            showGroup($field_dependent_group);
                        } else {
                            hideGroup($field_dependent_group);
                        }
                        
                    }
                    
                }
            
            });
            
        }
        
        function field_changed(evt) {
            
            // Get this field that has just changed
            var $this_field = $(this);
            
            checkDependentGroupsMatching($this_field);
            
        }
        
        function init() {
            
            $master_fields = $();
            
            $dependent_groups = $("[data-dependent-on]");
            
            if ($dependent_groups.length) {
                
                // For each element (e.g. divs, fieldset, field themselves declared through matrix Extras field) with the "data-dependent-on" attribute
                $dependent_groups.each(function( index ) {
                    
                    // Cache DOM element
                    var $dependent_group = $(this);
                    
                    // Extract the JSON attribute value from the element with the "data-dependent-on" attribute
                    // Example format:
                    /*
                    data-dependent-on='{
                        "q4750:q1": "4",
                        "q4750:q6": "*",
                    }'
                    */
                    // This means that this element is dependent on field with name q4750:q1 value to be 4 or q4750:q6 to be anything
                    
                    var dependent_group_map = $dependent_group.data("dependent-on");
                    
                    // Check if map is a properly defined object in the data attribute first
                    if (typeof dependent_group_map === "object") {
                        
                        // If dependent group is a field (data attribute has been applied through the matrix extras field)
                        // :input includes select
                        if ( $dependent_group.is(":input") )  {
                            
                            // Get the closest wrapper with class .sq-form-question and make this the dependent group instead
                            $dependent_group = $dependent_group.closest(".sq-form-question");
                            
                            // Set the map to the wrapper
                            $dependent_group.data("dependent-on", dependent_group_map);
                            
                        }
                        
                        // For each field name key in the dependent group map (e.g. q4750:q1, q4750:q6)
                        $.each( dependent_group_map, function( master_field_name ) {
                            
                            // Get the jQuery object of master field
                            // For checkboxes, matrix generates checkbox names ending with "[]" in the markup
                            // To keep things simple for the client, the name of the field is entered in to the data-dependent-on attribute without "[]"
                            var $master_field_element = $("[name='" + master_field_name + "'], [name='" + master_field_name + "[]']");
                            
                            //console.log(master_field_name);
                            //console.log($master_field_element.length);
                            
                            // If field element(s) exists
                            if ($master_field_element.length) {
                                
                                // dependent-groups will store jQuery objects of the dependent groups
                                // Get the current data value of data attribute dependent-groups
                                var field_element_dependent_groups_data = $master_field_element.data("dependent-groups");
    
                                // If no dependent_groups data added yet, 
                                if (!field_element_dependent_groups_data) {
                                    
                                    // Add the first dependent group in an array
                                    $master_field_element.data("dependent-groups", $dependent_group);
                                    
                                } else {
                                    
                                    // Add dependent group against the master field with the previously added ones
                                    // Using .add method to ensure elements in group is unique
                                    $master_field_element.data("dependent-groups", field_element_dependent_groups_data.add($dependent_group) );
                                    
                                    //console.log(field_element_dependent_groups_data.length);
                                    
                                }
                                
                                // At this point, each field in the map has data called "dependent-groups"
                                // It is an array which allows the field to keep track of what dependent groups are affected when changed
                                
                                // After mapping is done, we need this master_fields list of jQuery objects 
                                // to attach change handlers later once initial mapping is done
                                $master_fields = $master_fields.add($master_field_element);
                                
                            } else {
                                console.log("Element with name, " + master_field_name + ", does not exist!");
                            }
                            
                        });
                        
    
                    } else {
                        console.log("Mapping is not an object!");
                    }
                    
                });
                
                // At this point,  the form field mapping should be finished
                if ($master_fields.length) {
                    
                    // Bind change event on master fields
                    $master_fields.change(field_changed);
                    
                    //-------------------------------------------------------------
                    // Trigger change event for initial set up
                    //-------------------------------------------------------------
                    
                    // Trigger initial change event on each master select
                    var $master_select_fields = $master_fields.filter("select");
                    $master_select_fields.change();
                    
                    // Trigger initial change event on each master checkbox
                    var $master_checkboxes = $master_fields.filter(":checkbox");
                    $master_checkboxes.change();
                    
                    // Trigger initial change event on each radio field (Each field is a group of radios)
                    
                    // Get unique field names from radios
                    var $master_radios = $master_fields.filter(":radio");
                    
                    var master_radios_names = $master_radios.map(function() {
                        return $(this).prop("name");
                    }).get().filter( function(value, index, self) { return self.indexOf(value) === index; } );
                    
                    $.each(master_radios_names, function( index, name ) {
                        
                        var $master_radios = $("[name='" + name + "']");
                        
                        // Trigger on only one radio of each field to avoid unnecessary repetition    
                        $master_radios.first().change();
                        
                    });
                    
                }
                
            }
            
        }
        
        var $dependent_groups;
        var $master_fields;
        
        return {
            init: init
        }
    
    
    }());
    
    document.addEventListener("DOMContentLoaded", function() {
        form_dependent_group_module.init();
    });
    
    
}());